// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
   LOGIN MODAL — Custom overlay (no Bootstrap JS)
   ================================================================ */

.bv-auth-overlay.login-modal-container {
  position: fixed;
  inset: 0;
  z-index: var(--bv-z-modal, 100);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  animation: bv-auth-overlay-in 0.22s var(--bv-ease, ease);
}

.bv-auth-modal {
  width: 100%;
  max-width: 620px;
  max-height: calc(100vh - 2rem);
  overflow-y: auto;
  border-radius: var(--bv-radius-xl, 24px);
  background: var(--bv-white, #fff);
  box-shadow: var(--bv-shadow-lg, 0 24px 60px rgba(15, 23, 42, 0.16));
  animation: bv-auth-modal-in 0.28s var(--bv-ease-out, ease);
}

@keyframes bv-auth-overlay-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes bv-auth-modal-in {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* ---- Shell ---- */
.bv-login-modal {
  padding: var(--bv-space-5, 1.25rem) var(--bv-space-8, 2.5rem) var(--bv-space-5, 1.25rem);
  font-family: var(--bv-font-body, inherit);
}

.bv-login-modal__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 36px;
  margin-bottom: var(--bv-space-3, 0.75rem);
}

.bv-login-modal__toolbar-spacer {
  width: 72px;
}

.bv-login-modal__back,
.bv-login-modal__close {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  color: var(--bv-muted, #64748b);
  font-size: var(--bv-text-sm, 0.875rem);
  font-weight: 600;
  padding: 6px 10px;
  border-radius: var(--bv-radius-pill, 999px);
  cursor: pointer;
  transition: background var(--bv-dur, 280ms) var(--bv-ease, ease),
    color var(--bv-dur, 280ms) var(--bv-ease);
}

.bv-login-modal__back:hover,
.bv-login-modal__close:hover {
  background: var(--bv-bg-soft, #f8fafc);
  color: var(--bv-primary-700, #0f766e);
}

.bv-login-modal__close {
  width: 36px;
  height: 36px;
  padding: 0;
  justify-content: center;
  font-size: 1rem;
}

/* ---- Brand ---- */
.bv-login-modal__brand {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: var(--bv-space-4, 1rem);
  min-height: 88px;
}

.bv-login-modal__logo {
  display: block;
  width: min(480px, 92%);
  height: auto;
  max-height: 88px;
  min-height: 64px;
  object-fit: contain;
  object-position: center;
}

/* ---- Intro ---- */
.bv-login-modal__intro {
  text-align: center;
  margin-bottom: var(--bv-space-5, 1.25rem);
}

.bv-login-modal__title {
  font-family: var(--bv-font-display, inherit);
  font-size: var(--bv-text-2xl, 1.5rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--bv-ink, #0f172a);
  margin: 0 0 var(--bv-space-2, 0.5rem);
  line-height: 1.2;
}

.bv-login-modal__subtitle {
  margin: 0;
  font-size: var(--bv-text-sm, 0.875rem);
  color: var(--bv-muted, #64748b);
  line-height: 1.5;
  max-width: 32ch;
  margin-left: auto;
  margin-right: auto;
}

/* ---- Method cards ---- */
.bv-login-modal__methods {
  display: flex;
  flex-direction: column;
  gap: var(--bv-space-3, 0.75rem);
}

.bv-login-method-card {
  display: flex;
  align-items: center;
  gap: var(--bv-space-4, 1rem);
  width: 100%;
  padding: var(--bv-space-4, 1rem) var(--bv-space-5, 1.25rem);
  border: 1.5px solid var(--bv-line, #e2e8f0);
  border-radius: var(--bv-radius-lg, 18px);
  background: var(--bv-white, #fff);
  text-align: left;
  cursor: pointer;
  transition: border-color var(--bv-dur, 280ms) var(--bv-ease, ease),
    background var(--bv-dur, 280ms) var(--bv-ease, ease),
    box-shadow var(--bv-dur, 280ms) var(--bv-ease, ease),
    transform var(--bv-dur, 280ms) var(--bv-ease, ease);
}

.bv-login-method-card:hover:not(:disabled) {
  border-color: var(--bv-primary-line, #b8ebe4);
  background: var(--bv-primary-50, #e6f7f5);
  box-shadow: var(--bv-shadow-sm, 0 2px 8px rgba(15, 23, 42, 0.06));
  transform: translateY(-1px);
}

.bv-login-method-card:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.bv-login-method-card__icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: var(--bv-radius, 14px);
  background: var(--bv-grad-soft, linear-gradient(135deg, #e6f7f5 0%, #ccfbf1 100%));
  color: var(--bv-primary-700, #0f766e);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
}

.bv-login-method-card__text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.bv-login-method-card__label {
  font-family: var(--bv-font-display, inherit);
  font-size: var(--bv-text-base, 1rem);
  font-weight: 600;
  color: var(--bv-ink, #0f172a);
}

.bv-login-method-card__hint {
  font-size: var(--bv-text-sm, 0.875rem);
  color: var(--bv-muted, #64748b);
}

.bv-login-method-card__arrow {
  flex-shrink: 0;
  font-size: 0.75rem;
  color: var(--bv-muted-2, #94a3b8);
}

/* ---- Fields ---- */
.bv-login-modal__field {
  margin-bottom: var(--bv-space-5, 1.25rem);
}

.bv-login-modal__label {
  display: block;
  font-size: var(--bv-text-sm, 0.875rem);
  font-weight: 600;
  color: var(--bv-ink-2, #1e293b);
  margin-bottom: var(--bv-space-2, 0.5rem);
  text-align: left;
}

.bv-login-input-wrap {
  display: flex;
  align-items: stretch;
  border: 1.5px solid var(--bv-line, #e2e8f0);
  border-radius: var(--bv-radius, 14px);
  overflow: hidden;
  background: var(--bv-bg-soft, #f8fafc);
  transition: border-color var(--bv-dur-fast, 180ms) ease,
    box-shadow var(--bv-dur-fast, 180ms) ease;
}

.bv-login-input-wrap:focus-within {
  border-color: var(--bv-primary, #14b8a6);
  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.15);
  background: #fff;
}

.bv-login-input-wrap__prefix {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  font-size: var(--bv-text-sm, 0.875rem);
  font-weight: 600;
  color: var(--bv-muted, #64748b);
  background: var(--bv-line-soft, #f1f5f9);
  border-right: 1px solid var(--bv-line, #e2e8f0);
  flex-shrink: 0;
}

.bv-login-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  padding: 12px 14px;
  font-size: var(--bv-text-base, 1rem);
  font-weight: 500;
  color: var(--bv-ink, #0f172a);
  outline: none;
}

.bv-login-input::placeholder {
  color: var(--bv-muted-2, #94a3b8);
  font-weight: 400;
}

/* ---- Actions ---- */
.bv-login-modal__submit {
  width: 100%;
  margin-top: var(--bv-space-2, 0.5rem);
}

.bv-login-modal__submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* ---- OTP ---- */
.bv-login-modal__otp {
  text-align: center;
}

.bv-login-modal__otp .bv-login-modal__field {
  text-align: left;
}

.bv-login-modal__otp-inputs {
  margin: var(--bv-space-5, 1.25rem) 0;
}

.bv-login-otp-digit {
  border-color: var(--bv-line, #e2e8f0) !important;
  border-radius: var(--bv-radius-sm, 10px) !important;
  background: var(--bv-bg-soft, #f8fafc);
  color: var(--bv-ink, #0f172a);
  font-weight: 600;
  transition: border-color var(--bv-dur-fast, 180ms) ease,
    box-shadow var(--bv-dur-fast, 180ms) ease;
}

.bv-login-otp-digit:focus {
  outline: none;
  border-color: var(--bv-primary, #14b8a6) !important;
  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.15);
  background: #fff;
}

.bv-login-modal__resend {
  margin-top: var(--bv-space-4, 1rem);
}

.bv-login-modal__resend-timer {
  font-size: var(--bv-text-sm, 0.875rem);
  color: var(--bv-muted, #64748b);
}

.bv-login-modal__resend-btn {
  border: none;
  background: none;
  padding: 0;
  font-size: var(--bv-text-sm, 0.875rem);
  font-weight: 600;
  color: var(--bv-primary-700, #0f766e);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.bv-login-modal__resend-btn:hover {
  color: var(--bv-primary, #14b8a6);
}

/* ---- Footer ---- */
.bv-login-modal__footer {
  margin: var(--bv-space-6, 1.5rem) 0 0;
  padding-top: var(--bv-space-4, 1rem);
  border-top: 1px solid var(--bv-line-soft, #f1f5f9);
  font-size: var(--bv-text-xs, 0.75rem);
  color: var(--bv-muted-2, #94a3b8);
  text-align: center;
  line-height: 1.45;
}

/* Legacy selectors kept for any other modals using old classes */
.choose-user-type-sign {
  padding: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid var(--black) !important;
  color: var(--black);
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
}

.choose-user-type-sign.active {
  border: 0 !important;
  background: var(--primary);
  color: white;
}

.choose-user-type-sign .user-type-icon-sign {
  font-size: 18px;
  margin-right: 5px;
}

@media screen and (max-width: 575.98px) {
  .bv-auth-modal {
    max-height: calc(100vh - 1rem);
  }

  .bv-login-modal {
    padding: var(--bv-space-4, 1rem) var(--bv-space-5, 1.25rem) var(--bv-space-4, 1rem);
  }

  .bv-login-modal__brand {
    min-height: 72px;
  }

  .bv-login-modal__logo {
    width: min(360px, 96%);
    max-height: 72px;
    min-height: 52px;
  }

  .bv-login-modal__title {
    font-size: var(--bv-text-xl, 1.25rem);
  }

  .bv-login-method-card {
    padding: var(--bv-space-3, 0.75rem) var(--bv-space-4, 1rem);
  }

  .bv-login-method-card__icon {
    width: 40px;
    height: 40px;
  }
}

/* ---- Account delete confirm modal (custom, no window.alert/confirm) ---- */
dialog.ua-confirm-overlay {
  /* Reset native <dialog> sizing (defaults shrink to content → top-left) */
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  max-width: none;
  max-height: none;
  margin: 0;
  border: none;
  padding: 1rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  animation: bv-auth-overlay-in 0.22s var(--bv-ease, ease);
}

dialog.ua-confirm-overlay:not([open]) {
  display: none;
}

dialog.ua-confirm-overlay::backdrop {
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.ua-confirm-modal {
  width: 100%;
  max-width: 520px;
  background: var(--bv-white, #fff);
  border-radius: var(--bv-radius-xl, 24px);
  box-shadow: var(--bv-shadow-lg, 0 24px 60px rgba(15, 23, 42, 0.16));
  padding: 28px 28px 22px;
  animation: bv-auth-modal-in 0.28s var(--bv-ease-out, ease);
}

.ua-confirm-modal__title {
  margin: 0 0 8px;
  font-family: var(--bv-font-display, inherit);
  font-size: var(--bv-text-xl, 1.2rem);
  font-weight: 800;
  color: var(--bv-ink, #0f172a);
}

.ua-confirm-modal__message {
  margin: 0 0 16px;
  color: var(--bv-muted, #64748b);
  line-height: 1.5;
}

.ua-confirm-modal__actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 12px;
}

@media screen and (max-width: 575.98px) {
  dialog.ua-confirm-overlay {
    padding: 0.75rem;
  }

  .ua-confirm-modal {
    padding: 22px 20px 18px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/css/modal.css"],"names":[],"mappings":"AAAA;;qEAEqE;;AAErE;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,wCAAwC;EACxC,iCAAiC;EACjC,mEAAmE;EACnE,0DAA0D;AAC5D;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,oBAAoB;AACpB;EACE,wFAAwF;EACxF,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,eAAe;EACf;6CAC2C;AAC7C;;AAEA;;EAEE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;EACX,2DAA2D;EAC3D,2CAA2C;EAC3C,wCAAwC;EACxC,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf;;;uDAGqD;AACvD;;AAEA;EACE,6CAA6C;EAC7C,yCAAyC;EACzC,iEAAiE;EACjE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kFAAkF;EAClF,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;EACpC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,gBAAgB;EAChB,+BAA+B;EAC/B,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,2CAA2C;EAC3C,qCAAqC;EACrC,gBAAgB;EAChB,sCAAsC;EACtC;6CAC2C;AAC7C;;AAEA;EACE,wCAAwC;EACxC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,+BAA+B;EAC/B,wCAAwC;EACxC,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;EAChD,mDAAmD;EACnD,sCAAsC;EACtC,6BAA6B;EAC7B,gBAAgB;EAChB;6CAC2C;AAC7C;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,sCAAsC;EACtC,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB;EACE,qCAAqC;EACrC,oCAAoC;EACpC,kDAAkD;EAClD,qCAAqC;EACrC,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,mFAAmF;EACrF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,6EAA6E;AAC7E;EACE,yEAAyE;EACzE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,wDAAwD;AAC1D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,wCAAwC;EACxC,mEAAmE;EACnE,uBAAuB;EACvB,0DAA0D;AAC5D;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,oCAAoC;EACpC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* ================================================================\n   LOGIN MODAL — Custom overlay (no Bootstrap JS)\n   ================================================================ */\n\n.bv-auth-overlay.login-modal-container {\n  position: fixed;\n  inset: 0;\n  z-index: var(--bv-z-modal, 100);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  animation: bv-auth-overlay-in 0.22s var(--bv-ease, ease);\n}\n\n.bv-auth-modal {\n  width: 100%;\n  max-width: 620px;\n  max-height: calc(100vh - 2rem);\n  overflow-y: auto;\n  border-radius: var(--bv-radius-xl, 24px);\n  background: var(--bv-white, #fff);\n  box-shadow: var(--bv-shadow-lg, 0 24px 60px rgba(15, 23, 42, 0.16));\n  animation: bv-auth-modal-in 0.28s var(--bv-ease-out, ease);\n}\n\n@keyframes bv-auth-overlay-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes bv-auth-modal-in {\n  from {\n    opacity: 0;\n    transform: translateY(12px) scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* ---- Shell ---- */\n.bv-login-modal {\n  padding: var(--bv-space-5, 1.25rem) var(--bv-space-8, 2.5rem) var(--bv-space-5, 1.25rem);\n  font-family: var(--bv-font-body, inherit);\n}\n\n.bv-login-modal__toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 36px;\n  margin-bottom: var(--bv-space-3, 0.75rem);\n}\n\n.bv-login-modal__toolbar-spacer {\n  width: 72px;\n}\n\n.bv-login-modal__back,\n.bv-login-modal__close {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: none;\n  background: transparent;\n  color: var(--bv-muted, #64748b);\n  font-size: var(--bv-text-sm, 0.875rem);\n  font-weight: 600;\n  padding: 6px 10px;\n  border-radius: var(--bv-radius-pill, 999px);\n  cursor: pointer;\n  transition: background var(--bv-dur, 280ms) var(--bv-ease, ease),\n    color var(--bv-dur, 280ms) var(--bv-ease);\n}\n\n.bv-login-modal__back:hover,\n.bv-login-modal__close:hover {\n  background: var(--bv-bg-soft, #f8fafc);\n  color: var(--bv-primary-700, #0f766e);\n}\n\n.bv-login-modal__close {\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  justify-content: center;\n  font-size: 1rem;\n}\n\n/* ---- Brand ---- */\n.bv-login-modal__brand {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: var(--bv-space-4, 1rem);\n  min-height: 88px;\n}\n\n.bv-login-modal__logo {\n  display: block;\n  width: min(480px, 92%);\n  height: auto;\n  max-height: 88px;\n  min-height: 64px;\n  object-fit: contain;\n  object-position: center;\n}\n\n/* ---- Intro ---- */\n.bv-login-modal__intro {\n  text-align: center;\n  margin-bottom: var(--bv-space-5, 1.25rem);\n}\n\n.bv-login-modal__title {\n  font-family: var(--bv-font-display, inherit);\n  font-size: var(--bv-text-2xl, 1.5rem);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--bv-ink, #0f172a);\n  margin: 0 0 var(--bv-space-2, 0.5rem);\n  line-height: 1.2;\n}\n\n.bv-login-modal__subtitle {\n  margin: 0;\n  font-size: var(--bv-text-sm, 0.875rem);\n  color: var(--bv-muted, #64748b);\n  line-height: 1.5;\n  max-width: 32ch;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* ---- Method cards ---- */\n.bv-login-modal__methods {\n  display: flex;\n  flex-direction: column;\n  gap: var(--bv-space-3, 0.75rem);\n}\n\n.bv-login-method-card {\n  display: flex;\n  align-items: center;\n  gap: var(--bv-space-4, 1rem);\n  width: 100%;\n  padding: var(--bv-space-4, 1rem) var(--bv-space-5, 1.25rem);\n  border: 1.5px solid var(--bv-line, #e2e8f0);\n  border-radius: var(--bv-radius-lg, 18px);\n  background: var(--bv-white, #fff);\n  text-align: left;\n  cursor: pointer;\n  transition: border-color var(--bv-dur, 280ms) var(--bv-ease, ease),\n    background var(--bv-dur, 280ms) var(--bv-ease, ease),\n    box-shadow var(--bv-dur, 280ms) var(--bv-ease, ease),\n    transform var(--bv-dur, 280ms) var(--bv-ease, ease);\n}\n\n.bv-login-method-card:hover:not(:disabled) {\n  border-color: var(--bv-primary-line, #b8ebe4);\n  background: var(--bv-primary-50, #e6f7f5);\n  box-shadow: var(--bv-shadow-sm, 0 2px 8px rgba(15, 23, 42, 0.06));\n  transform: translateY(-1px);\n}\n\n.bv-login-method-card:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.bv-login-method-card__icon {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  border-radius: var(--bv-radius, 14px);\n  background: var(--bv-grad-soft, linear-gradient(135deg, #e6f7f5 0%, #ccfbf1 100%));\n  color: var(--bv-primary-700, #0f766e);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.15rem;\n}\n\n.bv-login-method-card__text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.bv-login-method-card__label {\n  font-family: var(--bv-font-display, inherit);\n  font-size: var(--bv-text-base, 1rem);\n  font-weight: 600;\n  color: var(--bv-ink, #0f172a);\n}\n\n.bv-login-method-card__hint {\n  font-size: var(--bv-text-sm, 0.875rem);\n  color: var(--bv-muted, #64748b);\n}\n\n.bv-login-method-card__arrow {\n  flex-shrink: 0;\n  font-size: 0.75rem;\n  color: var(--bv-muted-2, #94a3b8);\n}\n\n/* ---- Fields ---- */\n.bv-login-modal__field {\n  margin-bottom: var(--bv-space-5, 1.25rem);\n}\n\n.bv-login-modal__label {\n  display: block;\n  font-size: var(--bv-text-sm, 0.875rem);\n  font-weight: 600;\n  color: var(--bv-ink-2, #1e293b);\n  margin-bottom: var(--bv-space-2, 0.5rem);\n  text-align: left;\n}\n\n.bv-login-input-wrap {\n  display: flex;\n  align-items: stretch;\n  border: 1.5px solid var(--bv-line, #e2e8f0);\n  border-radius: var(--bv-radius, 14px);\n  overflow: hidden;\n  background: var(--bv-bg-soft, #f8fafc);\n  transition: border-color var(--bv-dur-fast, 180ms) ease,\n    box-shadow var(--bv-dur-fast, 180ms) ease;\n}\n\n.bv-login-input-wrap:focus-within {\n  border-color: var(--bv-primary, #14b8a6);\n  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.15);\n  background: #fff;\n}\n\n.bv-login-input-wrap__prefix {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 14px;\n  font-size: var(--bv-text-sm, 0.875rem);\n  font-weight: 600;\n  color: var(--bv-muted, #64748b);\n  background: var(--bv-line-soft, #f1f5f9);\n  border-right: 1px solid var(--bv-line, #e2e8f0);\n  flex-shrink: 0;\n}\n\n.bv-login-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  padding: 12px 14px;\n  font-size: var(--bv-text-base, 1rem);\n  font-weight: 500;\n  color: var(--bv-ink, #0f172a);\n  outline: none;\n}\n\n.bv-login-input::placeholder {\n  color: var(--bv-muted-2, #94a3b8);\n  font-weight: 400;\n}\n\n/* ---- Actions ---- */\n.bv-login-modal__submit {\n  width: 100%;\n  margin-top: var(--bv-space-2, 0.5rem);\n}\n\n.bv-login-modal__submit:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* ---- OTP ---- */\n.bv-login-modal__otp {\n  text-align: center;\n}\n\n.bv-login-modal__otp .bv-login-modal__field {\n  text-align: left;\n}\n\n.bv-login-modal__otp-inputs {\n  margin: var(--bv-space-5, 1.25rem) 0;\n}\n\n.bv-login-otp-digit {\n  border-color: var(--bv-line, #e2e8f0) !important;\n  border-radius: var(--bv-radius-sm, 10px) !important;\n  background: var(--bv-bg-soft, #f8fafc);\n  color: var(--bv-ink, #0f172a);\n  font-weight: 600;\n  transition: border-color var(--bv-dur-fast, 180ms) ease,\n    box-shadow var(--bv-dur-fast, 180ms) ease;\n}\n\n.bv-login-otp-digit:focus {\n  outline: none;\n  border-color: var(--bv-primary, #14b8a6) !important;\n  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.15);\n  background: #fff;\n}\n\n.bv-login-modal__resend {\n  margin-top: var(--bv-space-4, 1rem);\n}\n\n.bv-login-modal__resend-timer {\n  font-size: var(--bv-text-sm, 0.875rem);\n  color: var(--bv-muted, #64748b);\n}\n\n.bv-login-modal__resend-btn {\n  border: none;\n  background: none;\n  padding: 0;\n  font-size: var(--bv-text-sm, 0.875rem);\n  font-weight: 600;\n  color: var(--bv-primary-700, #0f766e);\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.bv-login-modal__resend-btn:hover {\n  color: var(--bv-primary, #14b8a6);\n}\n\n/* ---- Footer ---- */\n.bv-login-modal__footer {\n  margin: var(--bv-space-6, 1.5rem) 0 0;\n  padding-top: var(--bv-space-4, 1rem);\n  border-top: 1px solid var(--bv-line-soft, #f1f5f9);\n  font-size: var(--bv-text-xs, 0.75rem);\n  color: var(--bv-muted-2, #94a3b8);\n  text-align: center;\n  line-height: 1.45;\n}\n\n/* Legacy selectors kept for any other modals using old classes */\n.choose-user-type-sign {\n  padding: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid var(--black) !important;\n  color: var(--black);\n  font-size: 14px;\n  font-weight: 500;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.choose-user-type-sign.active {\n  border: 0 !important;\n  background: var(--primary);\n  color: white;\n}\n\n.choose-user-type-sign .user-type-icon-sign {\n  font-size: 18px;\n  margin-right: 5px;\n}\n\n@media screen and (max-width: 575.98px) {\n  .bv-auth-modal {\n    max-height: calc(100vh - 1rem);\n  }\n\n  .bv-login-modal {\n    padding: var(--bv-space-4, 1rem) var(--bv-space-5, 1.25rem) var(--bv-space-4, 1rem);\n  }\n\n  .bv-login-modal__brand {\n    min-height: 72px;\n  }\n\n  .bv-login-modal__logo {\n    width: min(360px, 96%);\n    max-height: 72px;\n    min-height: 52px;\n  }\n\n  .bv-login-modal__title {\n    font-size: var(--bv-text-xl, 1.25rem);\n  }\n\n  .bv-login-method-card {\n    padding: var(--bv-space-3, 0.75rem) var(--bv-space-4, 1rem);\n  }\n\n  .bv-login-method-card__icon {\n    width: 40px;\n    height: 40px;\n  }\n}\n\n/* ---- Account delete confirm modal (custom, no window.alert/confirm) ---- */\ndialog.ua-confirm-overlay {\n  /* Reset native <dialog> sizing (defaults shrink to content → top-left) */\n  position: fixed;\n  inset: 0;\n  width: 100vw;\n  height: 100vh;\n  max-width: none;\n  max-height: none;\n  margin: 0;\n  border: none;\n  padding: 1rem;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  background: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  animation: bv-auth-overlay-in 0.22s var(--bv-ease, ease);\n}\n\ndialog.ua-confirm-overlay:not([open]) {\n  display: none;\n}\n\ndialog.ua-confirm-overlay::backdrop {\n  background: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.ua-confirm-modal {\n  width: 100%;\n  max-width: 520px;\n  background: var(--bv-white, #fff);\n  border-radius: var(--bv-radius-xl, 24px);\n  box-shadow: var(--bv-shadow-lg, 0 24px 60px rgba(15, 23, 42, 0.16));\n  padding: 28px 28px 22px;\n  animation: bv-auth-modal-in 0.28s var(--bv-ease-out, ease);\n}\n\n.ua-confirm-modal__title {\n  margin: 0 0 8px;\n  font-family: var(--bv-font-display, inherit);\n  font-size: var(--bv-text-xl, 1.2rem);\n  font-weight: 800;\n  color: var(--bv-ink, #0f172a);\n}\n\n.ua-confirm-modal__message {\n  margin: 0 0 16px;\n  color: var(--bv-muted, #64748b);\n  line-height: 1.5;\n}\n\n.ua-confirm-modal__actions {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n@media screen and (max-width: 575.98px) {\n  dialog.ua-confirm-overlay {\n    padding: 0.75rem;\n  }\n\n  .ua-confirm-modal {\n    padding: 22px 20px 18px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
